import { Box, Flex, Heading, Image, Link } from "@chakra-ui/react";
import React from "react";
import GitHubCalendar from "react-github-calendar";

const Github = () => {
  return (
    <Box id="github" paddingTop={"10vh"}>
      <Heading marginTop="50px" mb="2rem" textAlign={"center"}>
        Github Statistics
      </Heading>
      <Box>
        <Box
          width={["330px", "450px", "870px"]}
          margin="auto"
          marginBottom={["40px", "60px", "60px"]}
        >
          <GitHubCalendar
            username="Ajay84sia"
            className="react-activity-calendar"
          />
        </Box>
        <Flex
          flexDir={{ base: "column", lg: "row" }}
          margin={"1rem"}
          align={"center"}
          justify={"center"}
          gap="7"
        >
          <Box
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1000"
          >
            <Link href="https://github.com/Ajay84sia" />
            <Image
              id="github-streak-stats"
              width="500px"
              src="https://github-readme-streak-stats.herokuapp.com?user=Ajay84sia&theme=react"
            />
          </Box>
          <Box data-aos="fade-up" data-aos-duration="3000">
            <Link href="https://github.com/Ajay84sia" />
            <Image
              id="github-top-langs"
              width="500px"
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=Ajay84sia&layout=compact&theme=react"
            />
          </Box>
          <Box
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1000"
          >
            <Link href="https://github.com/Ajay84sia" />
            <Image
              width="500px"
              id="github-stats-card"
              src="https://github-readme-stats.vercel.app/api?username=Ajay84sia&count_private=true&show_icons=true&theme=react"
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default Github;
